// removed by extract-text-webpack-plugin
module.exports = {"textBG":"textBG__W6DVa","textBGYellow":"textBGYellow__ggSDg","textBGGreen":"textBGGreen__3C6iA","textBGBlue":"textBGBlue__JD8_u","textBGTransparent":"textBGTransparent__3y49L","emoji":"emoji__kNqaE"};


//////////////////
// WEBPACK FOOTER
// ./components/TextWithBackground/style.css
// module id = 03Lb
// module chunks = 0